import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import { useEffect } from 'react';
import { UserRole, UserType } from '../../lib/interfaces/user';
import BannerPage from './page';

const BannerPageWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  // Kick user out if they are not an internal user with Administrator role
  useEffect(() => {
    if (!user || user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
      return;
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <BannerPage />
    </div>
  );
};

export default BannerPageWrapper;
